export enum EvaluationsTabValues {
  ENTITY = '0',
  PORTFOLIO = '1',
}

export enum EvaluationsTabs {
  ENTITY = 'Entity',
  PORTFOLIO = 'Portfolio',
}
